import LMSDispatcher from "../LMSDispatcher";

import * as CONSTANTS from "../../utilities/Constants";

import IActionHeaderFormData, { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";

class ActionHeaderActions {

    async common(data: IActionHeaderFormData) {        
        LMSDispatcher.dispatch({
            type: CONSTANTS.COMMON,
            payload: data 
        });
    }

    async edit(data: IActionHeaderEditData) {
        LMSDispatcher.dispatch({
            type: CONSTANTS.EDIT,
            payload: data 
        });        
    }
}

const actionHeaderActions = new ActionHeaderActions();
export default actionHeaderActions;